import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

import {
  CookieConsentContext,
  ConsentCategories,
} from '../../context/cookie-consent-context';

const CookieConsentBanner = () => {
  const { showBanner, consent, rejectAll, savePreferences, acceptAll } =
    useContext(CookieConsentContext);
  const [showPrefs, setShowPrefs] = useState(false);
  const [draft, setDraft] = useState<ConsentCategories>({
    analytics: consent.analytics,
    marketing: consent.marketing,
  });

  if (!showBanner) return null;

  const openPrefs = () => {
    setDraft({ analytics: consent.analytics, marketing: consent.marketing });
    setShowPrefs(true);
  };

  const toggle = (key: keyof ConsentCategories) =>
    setDraft((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className="cookie_consent_banner" role="dialog" aria-live="polite" aria-label="Aviso de cookies">
      <div className="cookie_consent_inner">
        {!showPrefs ? (
          <>
            <div className="cookie_consent_text">
              <p>
                Este sitio utiliza cookies analíticas para entender cómo lo usan
                nuestros visitantes y mejorar la experiencia. Al continuar navegando
                aceptas su uso.{' '}
                <Link to="/info/aviso" target="_blank" rel="noopener noreferrer">
                  Aviso de Privacidad
                </Link>
              </p>
            </div>
            <div className="cookie_consent_actions">
              <button className="btn_cookie btn_cookie_text" onClick={openPrefs}>
                Gestionar preferencias
              </button>
              <button className="btn_cookie btn_cookie_secondary" onClick={rejectAll}>
                Rechazar
              </button>
              <button className="btn_cookie btn_cookie_primary" onClick={acceptAll}>
                Entendido
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="cookie_consent_text">
              <strong>Preferencias de cookies</strong>
            </div>
            <div className="cookie_consent_categories">
              <div className="cookie_consent_category">
                <div>
                  <strong>Necesarias</strong>
                  <p>Requeridas para el funcionamiento del sitio (carrito, sesión). Siempre activas.</p>
                </div>
                <input type="checkbox" checked disabled readOnly />
              </div>
              <div className="cookie_consent_category">
                <div>
                  <strong>Analíticas</strong>
                  <p>Nos ayudan a entender cómo usas el sitio (Google Analytics).</p>
                </div>
                <input
                  type="checkbox"
                  checked={draft.analytics}
                  onChange={() => toggle('analytics')}
                />
              </div>
              <div className="cookie_consent_category">
                <div>
                  <strong>Marketing</strong>
                  <p>Usadas para mostrarte anuncios relevantes (Meta Pixel, Google Ads).</p>
                </div>
                <input
                  type="checkbox"
                  checked={draft.marketing}
                  onChange={() => toggle('marketing')}
                />
              </div>
            </div>
            <div className="cookie_consent_actions">
              <button
                className="btn_cookie btn_cookie_secondary"
                onClick={() => setShowPrefs(false)}
              >
                Atrás
              </button>
              <button
                className="btn_cookie btn_cookie_primary"
                onClick={() => savePreferences(draft)}
              >
                Guardar preferencias
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CookieConsentBanner;
